import { NODES_BASE_KEY } from '@/api/nodes/helpers/base-key'
import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'

interface IAddFileToDriveMutationParams {
    organizationId: string
    brandSlug: string

    name: string
    fileUuid: string
    parentNodePath?: string
}

export class AddFileToDriveMutation {
    static async call(api: IApi, { organizationId, brandSlug, ...payload }: IAddFileToDriveMutationParams) {
        return api
            .post<
                undefined,
                Omit<IAddFileToDriveMutationParams, 'organizationId' | 'brandSlug'>
            >(`organization/${organizationId}/brands/${brandSlug}/nodes/add-file-to-drive`, payload)
            .then((res) => res?.data)
    }
}

export const useAddFileToDriveMutation = () => {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation({
        mutationFn: (params: Omit<IAddFileToDriveMutationParams, 'organizationId' | 'brandSlug'>) => {
            const promise = AddFileToDriveMutation.call(api, {
                ...params,
                organizationId: apiParams.organizationId,
                brandSlug: apiParams.brandSlug,
            })

            return promise.then((res) => {
                return qc.invalidateQueries({ queryKey: NODES_BASE_KEY }).finally(() => {
                    return res
                })
            })
        },
    })
}
